import { useEffect, useState } from "react";

import Modal from "./Modal";
import Button from "./Button";
import FormInput from "./FormInput";

function OperatorModal({
  open,
  onClose,
  onSave,
  operator,
}) {
  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    telefono: "",
    email: "",
    cbuCvu: "",
    alias: "",
    comision: 30,
    activo: true,
    observaciones: "",
  });

  useEffect(() => {
    if (operator) {
      setForm({ ...operator, cbuCvu: operator.cbuCvu || "", alias: operator.alias || "" });
    } else {
      setForm({
        nombre: "",
        apellido: "",
        telefono: "",
        email: "",
        cbuCvu: "",
        alias: "",
        comision: 30,
        activo: true,
        observaciones: "",
      });
    }
  }, [operator]);

  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={
        operator
          ? "Editar Operador"
          : "Nuevo Operador"
      }
    >
      <FormInput
        label="Nombre"
        value={form.nombre}
        onChange={(e) =>
          handleChange(
            "nombre",
            e.target.value
          )
        }
      />

      <FormInput
        label="Apellido"
        value={form.apellido}
        onChange={(e) =>
          handleChange(
            "apellido",
            e.target.value
          )
        }
      />

      <FormInput
        label="Teléfono"
        value={form.telefono}
        onChange={(e) =>
          handleChange(
            "telefono",
            e.target.value
          )
        }
      />

      <FormInput
        label="Email"
        value={form.email}
        onChange={(e) =>
          handleChange(
            "email",
            e.target.value
          )
        }
      />

      <FormInput
        label="CBU / CVU"
        placeholder="22 dígitos"
        value={form.cbuCvu}
        onChange={(e) => handleChange("cbuCvu", e.target.value)}
      />

      <FormInput
        label="Alias"
        placeholder="alias.ejemplo"
        value={form.alias}
        onChange={(e) => handleChange("alias", e.target.value)}
      />

      <FormInput
        label="Comisión (%)"
        type="number"
        value={form.comision}
        onChange={(e) =>
          handleChange(
            "comision",
            Number(e.target.value)
          )
        }
      />

      <FormInput
        label="Observaciones"
        value={form.observaciones}
        onChange={(e) =>
          handleChange(
            "observaciones",
            e.target.value
          )
        }
      />

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: 12,
          marginTop: 20,
        }}
      >
        <Button
          variant="secondary"
          onClick={onClose}
        >
          Cancelar
        </Button>

        <Button
          onClick={() => onSave(form)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default OperatorModal;
